function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input as BaseInput } from "sprout-ui-dom/dist/Form";
import { Button as BaseButton, Button } from "sprout-ui-dom/dist/Button";
import { createElement, useCallback, useRef } from "react";
import { Box, Flex } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { CancelOutlined, TaskAltOutlined } from "sprout-ui-icons";
import { colorMap } from "@sprout/client-lib/dist/labels_next";
import { media } from "sprout-ui-theme";
import RenderIfChildExists from "../../RenderIfChildExists";
const StyledFlex = styled(Flex)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 8px;
`;
const StyledFlex2 = styled(Flex)`
  button {
    width: 32px;
    height: 32px;
  }

  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 8px;
`;
export const LabelsDialogInputButton = styled(BaseButton)`
  width: 32px;
  height: 32px;
`;
const LabelsDialogInputWrapper = styled(Box)`
  position: relative;

  ${({ $hideOnTouchDevices  })=>$hideOnTouchDevices && css`
      ${media.target("touch")} {
        display: none;
      }

      ${media.down("small", "pointer")} {
        display: none;
      }
    `}
`;
const Input = styled(BaseInput)`
  ${({ $prependIcon  })=>$prependIcon && css`
      padding-left: 40px;
    `}

  ${({ $appendIcon  })=>$appendIcon && css`
      padding-right: ${$appendIcon * 32 + 8}px;
    `}
`;
const LabelsDialogInput = (props)=>{
    const { onRequestClose , className , hideOnTouchDevices , placeholder , prependIcon , autoFocus , value , onChange , getInputProps , onCancel , onSubmit ,  } = props;
    const inputRef = useRef(null);
    const handleCancel = useCallback(()=>{
        var ref;
        if (onCancel) onCancel();
        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        onCancel
    ]);
    const handleKeyDown = useCallback((event)=>{
        if (event.key === "Escape" && event.currentTarget.value.length === 0) onRequestClose(new Error("Closing `LabelsDialog"));
    }, [
        onRequestClose
    ]);
    return /*#__PURE__*/ _jsxs(LabelsDialogInputWrapper, {
        $hideOnTouchDevices: !!hideOnTouchDevices,
        flex: "auto",
        className: className,
        children: [
            prependIcon && /*#__PURE__*/ _jsx(StyledFlex, {
                as: "span",
                color: "black.60",
                children: /*#__PURE__*/ createElement(prependIcon)
            }),
            /*#__PURE__*/ _jsx(Input, _objectSpread({
                placeholder: placeholder,
                $prependIcon: !!prependIcon,
                $appendIcon: onCancel && onSubmit ? 2 : onCancel || onSubmit ? 1 : undefined
            }, getInputProps ? getInputProps({
                ref: inputRef,
                onKeyDown: handleKeyDown
            }) : {
                ref: inputRef,
                value,
                onChange,
                onKeyDown: handleKeyDown
            }, {
                autoFocus: autoFocus
            })),
            /*#__PURE__*/ _jsxs(RenderIfChildExists, {
                component: /*#__PURE__*/ _jsx(StyledFlex2, {
                    alignItems: "center"
                }),
                children: [
                    onCancel && /*#__PURE__*/ _jsx(Button, {
                        variant: "circle",
                        onClick: handleCancel,
                        color: colorMap.red,
                        children: /*#__PURE__*/ _jsx(CancelOutlined, {})
                    }),
                    onSubmit && /*#__PURE__*/ _jsx(Button, {
                        variant: "circle",
                        type: "submit",
                        color: colorMap.green,
                        children: /*#__PURE__*/ _jsx(TaskAltOutlined, {})
                    })
                ]
            })
        ]
    });
};
export default LabelsDialogInput;
